export const targetIsInput = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target?.tagName === 'INPUT' ||
    target?.tagName === 'TEXTAREA' ||
    target?.contentEditable === 'true');
